import { render } from "./PortfolioBox.vue?vue&type=template&id=32a2d0e7&scoped=true"
const script = {}

import "./PortfolioBox.vue?vue&type=style&index=0&id=32a2d0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a2d0e7"]])

export default __exports__